// src/components/template-builder-v2/types.ts
export enum TemplateType {
  PAGE = 'page_template',
  CUSTOM = 'custom_template'
}

export type FieldType =
  | 'text'
  | 'textarea'
  | 'rich-text'
  | 'number'
  | 'date'
  | 'time'
  | 'datetime'
  | 'email'
  | 'url'
  | 'phone'
  | 'image'
  | 'file'
  | 'select'
  | 'radio'
  | 'checkbox'
  | 'container'
  | 'table'
  | 'custom_template'
  | 'checklist'
  | 'profile';

export interface FieldSettings {
  required?: boolean;
  placeholder?: string;
  rows?: number;
  min?: number;
  max?: number;
  options?: string[];
  allowedTypes?: string;
  isMulti?: boolean;
  [key: string]: any;
}

export interface Field {
  id: string;
  type: FieldType;
  label: string;
  key: string;
  settings: FieldSettings;
  children?: Field[];
  parentId: string | null;
  order?: number;
  templateName?: string;
  templateFields?: Field[];
  isSinglePage?: boolean;
}

export interface CustomTemplate {
  templateName?: string;
  name: string;
  description: string;
  fields: Field[];
}

export interface TemplateForm {
  templateType: TemplateType;
  templateId?: string;
  templateName: string;
  templateDescription: string;
  lastUpdatedBy?: string;
  updatedAt?: string;
  fields: Field[];
  isSinglePage?: boolean;
  pageKey?: string;
  needsSeo?: boolean;
}